import { configureStore } from '@reduxjs/toolkit';
import envsReducer from './slices/envsSlice';
import helpersReducer from './slices/helpersSlice';
import profileReducer from './slices/profileSlice';
import campaignsReducer from './slices/campaignsSlice';
import myCampaignsReducer from './slices/myCampaignsSlice';

export const store = configureStore({
  reducer: {
    envs: envsReducer,
    helpers: helpersReducer,
    profile: profileReducer,
    campaigns: campaignsReducer,
    myCampaigns: myCampaignsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
